import { Box, Grid, Skeleton } from "@mui/material";

import styled from "@emotion/styled";

export default function CardSkeleton({ heightSize }) {
  return (
    <Grid container spacing={2}>
      <Grid xs={12} item>
        <Box py={1}>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>
    </Grid>
  );
}

const SkeletonStyle = styled(Skeleton)(() => ({
  borderRadius: "10px",
}));
